import { Converter } from '../types/converter';

export const surfaceTensionConverter: Converter = {
  id: 'surfaceTension',
  name: 'Surface Tension Converter',
  icon: 'Droplet',
  categories: ['engineering', 'fluids'],
  units: [
    // Base SI unit
    { name: 'Newton/meter', symbol: 'N/m', factor: 1 },
    { name: 'Millinewton/meter', symbol: 'mN/m', factor: 0.001 },
    { name: 'Gram-force/centimeter', symbol: 'gf/cm', factor: 0.980665 },
    { name: 'Dyne/centimeter', symbol: 'dyn/cm', factor: 0.001 },
    { name: 'Erg/square centimeter', symbol: 'erg/cm²', factor: 0.001 },
    { name: 'Erg/square millimeter', symbol: 'erg/mm²', factor: 0.01 },
    { name: 'Poundal/inch', symbol: 'pdl/in', factor: 0.138255 },
    { name: 'Pound-force/inch', symbol: 'lbf/in', factor: 4.448222 }
  ]
};
